// Shop Per Player Tab Functionality
(function() {
  'use strict';

  function initShopPerPlayer(container) {
    const tabs = container.querySelectorAll('.shop-per-player__tab');
    const playerItems = container.querySelectorAll('.shop-per-player__item');
    const slider = container.querySelector('slider-component');
    let activeCategory = 'keeper'; // Default category

    if (!tabs.length || !playerItems.length) return;

    function setActiveTab(category) {
      tabs.forEach(tab => {
        const isActive = tab.dataset.category === category;
        tab.classList.toggle('shop-per-player__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function sortPlayersByOrder(items) {
      // Convert NodeList to Array for sorting
      const itemsArray = Array.from(items);
      
      // Sort by order attribute (lower numbers first)
      itemsArray.sort((a, b) => {
        const orderA = parseInt(a.dataset.order) || 9999;
        const orderB = parseInt(b.dataset.order) || 9999;
        return orderA - orderB;
      });
      
      // Re-append sorted items to maintain order in DOM
      const parent = items[0]?.parentElement;
      if (parent) {
        itemsArray.forEach(item => {
          parent.appendChild(item);
        });
      }
    }

    function filterPlayers(category) {
      let visibleCount = 0;
      const visibleItems = [];
      
      playerItems.forEach(item => {
        const itemCategory = item.dataset.category?.toLowerCase();
        const shouldShow = itemCategory === category.toLowerCase();

        if (shouldShow) {
          item.classList.remove('shop-per-player__item--hidden');
          item.style.display = '';
          visibleItems.push(item);
          visibleCount++;
        } else {
          item.classList.add('shop-per-player__item--hidden');
          item.style.display = 'none';
        }
      });
      
      // Sort visible players by order
      if (visibleItems.length > 0) {
        sortPlayersByOrder(visibleItems);
      }

      // Hide/show slider buttons based on visible count
      const sliderButtons = container.querySelector('.slider-buttons');
      if (sliderButtons) {
        if (visibleCount <= 5) {
          sliderButtons.style.display = 'none';
        } else {
          sliderButtons.style.display = 'flex';
        }
      }

      // Update slider if it exists
      if (slider) {
        setTimeout(() => {
          if (slider.resetPages && typeof slider.resetPages === 'function') {
            slider.resetPages();
          } else if (slider.initPages && typeof slider.initPages === 'function') {
            slider.initPages();
          }
        }, 200);
      }
    }

    function handleTabClick(event) {
      const tab = event.currentTarget;
      const category = tab.dataset.category;

      if (!category) return;

      activeCategory = category;
      setActiveTab(category);
      filterPlayers(category);

      // Reset slider position when filtering
      if (slider) {
        const sliderElement = slider.querySelector('[id^="Slider-"]');
        if (sliderElement) {
          sliderElement.scrollLeft = 0;
        }
      }
    }

    // Sort all players by order on initial load
    if (playerItems.length > 0) {
      sortPlayersByOrder(playerItems);
    }

    // Set initial active tab
    setActiveTab(activeCategory);

    // Add click handlers to tabs
    tabs.forEach(tab => {
      tab.addEventListener('click', handleTabClick);
    });

    // Filter players on load
    filterPlayers(activeCategory);
  }

  // Initialize on DOM ready
  function initialize() {
    const shopPerPlayerSections = document.querySelectorAll('.shop-per-player');
    shopPerPlayerSections.forEach(section => {
      initShopPerPlayer(section);
    });
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
